import React from 'react';
import { Navigate, useLocation } from 'react-router';

function InviteOnlyRoute({ children }) {
  const { state } = useLocation();
  const location = useLocation();
  return state?.entityId ? children : <Navigate to="/" replace state={{ path: location.pathname }} />;
}
export default InviteOnlyRoute;
